export default __webpack_public_path__ + "static/media/flips_2026_coupon.5260dd76.png";